export default __webpack_public_path__ + "static/media/removeItem.80d1a46e.svg";